import React, { useRef } from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import Img from "gatsby-image"
import { MDXRenderer } from "gatsby-plugin-mdx"
import { motion } from "framer-motion"

import { useOnScreen } from "../../hooks"
import ContentWrapper from "../../styles/ContentWrapper"
import Underlining from "../../styles/Underlining"
import Social from "../social"

const StyledSection = styled(motion.section)`
  width: 100%;
  height: auto;
  background: ${({ theme }) => theme.colors.background};
  margin-top: 6rem;
  display: flex;
  justify-content: center;
`

const StyledContentWrapper = styled(ContentWrapper)`
  && {
    width: 100%;
    /* Don't stretch container over the full page width */
    max-width: 45rem;
    height: 100%;
    margin: 0 auto;
    display: inline-block;
    p {
      margin-top: 0;
      margin-bottom: 0;
    }
    h2 {
      font-size: 1.5rem;
      margin-right: 2rem;
      text-align: center;
      @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
        font-size: 3rem;
      }
    }
    .social {
      display: flex;
      justify-content: center;
    }
    .profile {
      display: flex;
      flex-direction: column;

      justify-content: flex-start;
      margin-top: 3rem;
      margin-bottom: 2rem;
      @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
        flex-direction: row;
        align-items: center;
        margin-bottom: 3rem;
      }

      .avatar {
        width: 100%;
        max-width: 8.75rem;
        border-radius: 50%;
        margin-right: 4rem;
        margin-bottom: 2rem;
        @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
          margin-bottom: 0;
        }
      }
      .details {
        font-size: 1rem;
        line-height: 2rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
          font-size: 2rem;
        }
      }
    }
  }
`

const Contact = ({ content }) => {
  const { body, frontmatter } = content[0].node

  // Required for animation
  const ref = useRef()
  const onScreen = useOnScreen(ref)
  const variants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0 },
  }

  return (
    <StyledSection
      id="contact"
      ref={ref}
      variants={variants}
      animate={onScreen ? "visible" : "hidden"}
    >
      <StyledContentWrapper>
        <h2>{frontmatter.title}</h2>
        <MDXRenderer>{body}</MDXRenderer>
        <div className="profile">
          <div className="details">
            <strong>{frontmatter.name}</strong>
            <br />
            <a href={`mailto:${frontmatter.email}`}>
              <Underlining color="secondary" hoverColor="secondary">
                Let's Talk
              </Underlining>
            </a>
          </div>
        </div>
        <div className="social">
          <Social width="9rem" padding="0.5rem 1.25rem" withIcon />
        </div>
      </StyledContentWrapper>
    </StyledSection>
  )
}

Contact.propTypes = {
  content: PropTypes.arrayOf(
    PropTypes.shape({
      node: PropTypes.shape({
        body: PropTypes.string.isRequired,
        frontmatter: PropTypes.object.isRequired,
      }).isRequired,
    }).isRequired
  ).isRequired,
}

export default Contact
